// Preset captions for property photos. Free text is always allowed — these
// just feed the <datalist> autocomplete so labels stay fast and consistent.
// MUST stay identical to PHOTO_LABEL_PRESETS in mobile/utils/constants.ts.
export const PHOTO_LABEL_PRESETS = [
  'Fachada',
  'Sala',
  'Comedor',
  'Cocina',
  'Dormitorio principal',
  'Dormitorio 2',
  'Dormitorio 3',
  'Baño',
  'Estudio',
  'Terraza',
  'Balcón',
  'Jardín',
  'Piscina',
  'Garaje',
  'Bodega',
  'Lavandería',
  'Vista',
  'Área social',
  'Gimnasio',
  'Recepción',
];
